import { render, staticRenderFns } from "./PerEmp.vue?vue&type=template&id=2596ce8a&scoped=true&"
import script from "./PerEmp.vue?vue&type=script&lang=js&"
export * from "./PerEmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596ce8a",
  null
  
)

export default component.exports